import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const ModuleBasicInfoComponent = ({  
    selectLMSModules, handleInnerFormChange,EntityTypeList,CollectionsList,CourseList,learningpathList  
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Entity Type"
                            labelField="Text"
                            list={EntityTypeList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'EntityTypeId'
                                )
                            }}
                            optionName='Choose Entity Type'
                            type="select"
                            value={selectLMSModules?.EntityTypeId}
                            valueField="Value"
                        />
                            {selectLMSModules?.EntityTypeId === 113 && (
                            <InputContainer
                                label="Entity"
                                labelField="Title"
                                list={CourseList}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'courseId'
                                    );
                                }}
                                optionName='Choose course'
                                type="select"
                                value={selectLMSModules?.courseId}
                                valueField="Id"
                            />
                        )}
                        {selectLMSModules?.EntityTypeId === 116 && (
                            <InputContainer
                                label="Entity"
                                labelField="collections"
                                list={CollectionsList}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'collectionsId'
                                    );
                                }}
                                optionName='Choose collections'
                                type="select"
                                value={selectLMSModules?.collectionsId}
                                valueField="Id"
                            />
                        )}
                        {selectLMSModules?.EntityTypeId === 115 && (
                            <InputContainer
                                label="Entity"
                                labelField="learningpath"
                                list={learningpathList}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'learningpathId'
                                    );
                                }}
                                optionName='Choose learning path'
                                type="select"
                                value={selectLMSModules?.learningpathId}
                                valueField="Id"
                            />
                        )}
                        <InputContainer
                            label="Title"
                            labelField="Title"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Title'
                                );
                            }}
                            type="text"
                            value={selectLMSModules?.Title}  
                        />

                       
                       
                            <InputContainer
                                label="Short Description"
                                name="Short Description"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'shortID'
                                    )
                                }}
                                type="text"
                                value={selectLMSModules?.shortID}  
                            />

                        <div className='col-span-full'>
                            <InputContainer
                                label="Description"
                                name="Description"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                        'Description'
                                    )
                                }}
                                type="rte"
                                value={selectLMSModules?.Description}  
                            />
                        </div>
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Module Basic Info"  
            />
        </>
    )
}

export default ModuleBasicInfoComponent;  
